<template>
  <div class="component-referrals">
    <div class="referrals-top">
      <h1 class="title">Record of Participation</h1>
      <p class="desc">Please fill in the participation form</p>
    </div>

    <div class="participation-form">
      <div class="count">
        <div class="text">Number of Participants:</div>
        <FormInput
          type="text"
          restrict
          placeholder="0"
          v-model.trim="v$.form1.participationCount.$model"
          :valid="!v$.form1.participationCount.$error"
          @input="updateWorkshopInfo"
        />
      </div>

      <div class="age-range">
        <div class="text">Participant Age Range:</div>
        <FormInput
          type="text"
          restrict
          placeholder="0"
          v-model.trim="v$.form1.minAge.$model"
          :valid="!v$.form1.minAge.$error"
          @input="updateWorkshopInfo"
        />
        <div class="text to">to</div>
        <FormInput
          type="text"
          restrict
          placeholder="0"
          v-model.trim="v$.form1.maxAge.$model"
          :valid="!v$.form1.maxAge.$error"
          @input="updateWorkshopInfo"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { useVuelidate } from '@vuelidate/core';
import { required, integer, minValue } from '@vuelidate/validators';
import { ref, computed } from 'vue';

import FormInput from '@/components/form/elements/FormInput.vue';

const emit = defineEmits(['updateWorkshopInfo']);

const form1 = ref({
  participationCount: null,
  minAge: null,
  maxAge: null,
});

const rules = computed(() => ({
  form1: {
    participationCount: {
      required,
      integer,
      minValue: minValue(1),
    },
    minAge: {
      required,
      integer,
      minValue: minValue(1),
    },
    maxAge: {
      required,
      integer,
      minValue: minValue(1),
    },
  },
}));

const v$ = useVuelidate(rules, { form1 });

function updateWorkshopInfo() {
  // if (v$.form1.$invalid) return;
  // if (form1.minAge < 12) return;
  // if (form1.minAge >= form1.maxAge) return;

  emit('updateWorkshopInfo', {
    participationCount: form1.value.participationCount,
    minAge: form1.value.minAge,
    maxAge: form1.value.maxAge,
  });
}
</script>

<style scoped>
.component-referrals {
  display: flex;
  flex-direction: column;

  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 0 1em;
}

.referrals-top .title {
  margin: 1em 0 0;
  padding: 0;
}
.referrals-top .desc {
  font-size: 1.1em;
  color: #6d6e71;
}

.participation-form {
  display: flex;
  flex-direction: column;
  color: rgb(99, 99, 99);
}

.participation-form .count {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  width: 100%;
}
.participation-form .age-range {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  width: 100%;
}

.participation-form .count .text,
.participation-form .age-range .text {
  white-space: nowrap;
  margin: 0 0.8em 0.2em 0;
}

.participation-form .count .form-input {
  flex-grow: 1;
  margin-right: 0.8em;
  max-width: 6em;
}
.participation-form .age-range .form-input {
  margin-right: 0.8em;
  width: 2em;
}

/** Larger devices */
@media only screen and (min-width: 601px) and (min-height: 601px) {
  .component-referrals {
    padding: 2em 1em;
  }

  .participation-form {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    max-width: 40em;
  }

  .participation-form .count {
    grid-template-columns: 11em 3em;
    width: initial;
  }
  .participation-form .age-range {
    grid-template-columns: 10em 3em 2em 3em;
    width: initial;
  }
}
</style>
